(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8671],{

/***/ 4599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[category]",
      function () {
        return __webpack_require__(2024);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FivaLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51146);
/* harmony import */ var _components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31552);



function FivaLayout(param) {
    var children = param.children, blue = param.blue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FivaNavLayout_FivaNavLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer_FivaFooter_FivaFooter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                blue: blue
            })
        ]
    });
}


/***/ }),

/***/ 7647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42846);
/* harmony import */ var _ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_imageUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14709);
/* harmony import */ var _utils_dateUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62653);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25968);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6226);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83062);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);







var ArticleList = function(param) {
    var articles = param.articles;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        gutter: [
            16,
            80
        ],
        children: articles === null || articles === void 0 ? void 0 : articles.map(function(param, idx) {
            var title = param.title, small_image = param.small_image, date = param.date, slug = param.slug;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                xs: {
                    span: 24
                },
                sm: {
                    span: 24
                },
                md: {
                    span: 24
                },
                lg: {
                    span: 24
                },
                xl: {
                    span: 12
                },
                xxl: {
                    span: 8
                },
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/articulo/".concat(slug),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().cardWrap),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().imageWrapper),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            alt: title,
                                            src: (0,_utils_imageUtils__WEBPACK_IMPORTED_MODULE_6__/* .transformCloudinaryURL */ .V)(small_image),
                                            className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().cardImage),
                                            layout: "fill"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            alt: "Decorative overlay",
                                            src: "/icons/corner-blue.png",
                                            className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().overlayImage)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().textWrap),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            title: title,
                                            mouseEnterDelay: 1,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().cardTitle),
                                                children: title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().text),
                                            children: (0,_utils_dateUtils__WEBPACK_IMPORTED_MODULE_8__/* .StringToESDate */ .aM)(date)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                color: "var(--fiva-color)",
                                                textDecoration: "underline 2px"
                                            },
                                            className: (_ArticleList_module_css__WEBPACK_IMPORTED_MODULE_5___default().text),
                                            children: "Leer m\xe1s"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleList);


/***/ }),

/***/ 89234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TopicList_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61622);
/* harmony import */ var _TopicList_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_TopicList_module_css__WEBPACK_IMPORTED_MODULE_2__);



var TopicList = function(param) {
    var topics = param.topics, selected = param.selected;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_TopicList_module_css__WEBPACK_IMPORTED_MODULE_2___default().topicList),
        children: topics === null || topics === void 0 ? void 0 : topics.map(function(param, idx) {
            var title = param.title, slug = param.slug;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/categoria/".concat(slug),
                passHref: true,
                children: selected === slug ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: (_TopicList_module_css__WEBPACK_IMPORTED_MODULE_2___default().selectedTopicCard),
                    children: title
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: (_TopicList_module_css__WEBPACK_IMPORTED_MODULE_2___default().topicCard),
                    children: title
                })
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicList);


/***/ }),

/***/ 98931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useWindowDimensions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindowDimensions = function() {
    var getWindowDimensions = function getWindowDimensions() {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height
        };
    };
    var hasWindow = "object" !== "undefined";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (hasWindow) {
            var handleResize = function() {
                setWindowDimensions(getWindowDimensions());
            };
            window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResize);
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, [
        hasWindow
    ]);
    return windowDimensions;
};


/***/ }),

/***/ 2024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/babel-plugin-superjson-next/tools.js
var tools = __webpack_require__(23544);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/_Blog/SingleCategory/SingleCategory.module.css
var SingleCategory_module = __webpack_require__(12968);
var SingleCategory_module_default = /*#__PURE__*/__webpack_require__.n(SingleCategory_module);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.tsx
var useWindowDimensions = __webpack_require__(98931);
// EXTERNAL MODULE: ./components/_Blog/ArticleList/ArticleList.tsx
var ArticleList = __webpack_require__(7647);
// EXTERNAL MODULE: ./node_modules/@mui/material/Pagination/Pagination.js + 15 modules
var Pagination = __webpack_require__(15586);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/_Blog/TopicList/TopicList.tsx
var TopicList = __webpack_require__(89234);
;// CONCATENATED MODULE: ./components/_Blog/SingleCategory/SingleCategory.tsx










var ARTICLES_PER_PAGE = 9;
var SingleCategory = function(param) {
    var topics = param.topics, category = param.category;
    var articles = category === null || category === void 0 ? void 0 : category.blog;
    var width = (0,useWindowDimensions/* useWindowDimensions */.d)().width;
    var router = (0,next_router.useRouter)();
    var topicListRef = (0,react.useRef)(null);
    var currentPage = parseInt(router.query.page) || 1;
    var totalPages = Math.ceil((articles === null || articles === void 0 ? void 0 : articles.length) / ARTICLES_PER_PAGE);
    var currentArticles = articles === null || articles === void 0 ? void 0 : articles.slice((currentPage - 1) * ARTICLES_PER_PAGE, currentPage * ARTICLES_PER_PAGE);
    var handlePageChange = function(event, value) {
        var categoryValue = router.query.category;
        var newPath = "/categoria/".concat(categoryValue, "?page=").concat(value);
        router.push(newPath, undefined, {
            shallow: true
        }).then(function() {
            if (topicListRef.current) {
                window.scrollTo({
                    top: topicListRef.current.offsetTop - 100,
                    behavior: "smooth"
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SingleCategory_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SingleCategory_module_default()).containerWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: width <= 850 ? "/Images/blog-image-phone.svg" : "/Images/blog-image.svg",
                        alt: "Portada blog",
                        layout: "fill",
                        objectFit: "cover",
                        className: (SingleCategory_module_default()).imgRadius
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SingleCategory_module_default()).textWrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (SingleCategory_module_default()).title,
                            children: category === null || category === void 0 ? void 0 : category.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: topicListRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicList/* default */.Z, {
                    topics: topics,
                    selected: category === null || category === void 0 ? void 0 : category.slug
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
                articles: currentArticles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                variant: "outlined",
                count: totalPages,
                page: currentPage,
                onChange: handlePageChange,
                sx: {
                    margin: "4rem 0rem",
                    display: "flex",
                    justifyContent: "center",
                    gap: "2rem",
                    "& .MuiPaginationItem-root": {
                        color: "var(--fiva-color)",
                        backgroundColor: "#DDFFFD",
                        width: "50px",
                        height: "50px",
                        borderRadius: "50px",
                        fontSize: "20px"
                    },
                    "& .Mui-selected": {
                        color: "var(--fiva-color)",
                        backgroundColor: "#00F5EA"
                    },
                    "& .MuiPaginationItem-root:hover": {
                        backgroundColor: "rgba(0, 245, 234, 0.5)"
                    },
                    "& .MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#00F5EA"
                    },
                    "& .MuiPagination-ul": {
                        gap: "1rem"
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var SingleCategory_SingleCategory = (SingleCategory);

// EXTERNAL MODULE: ./components/HeadComponent/HeadComponent.tsx
var HeadComponent = __webpack_require__(65722);
// EXTERNAL MODULE: ./Layout/FivaLayout.tsx
var FivaLayout = __webpack_require__(32399);
;// CONCATENATED MODULE: ./pages/categoria/[category].tsx






var Category = function Category(param) {
    var data = param.data, topics = param.topics;
    var headerProps = {
        title: data ? data.headers.title : "",
        keywords: data ? data.headers.keywords : "",
        content: data ? data.headers.content : ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FivaLayout/* default */.Z, {
        blue: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadComponent/* default */.Z, (0,_object_spread/* default */.Z)({}, headerProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleCategory_SingleCategory, {
                category: data,
                topics: topics
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _category_ = ((0,tools.withSuperJSONPage)(Category));


/***/ }),

/***/ 62653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IL": function() { return /* binding */ FormatSlugDate; },
/* harmony export */   "NI": function() { return /* binding */ FormatDateCurrentDate; },
/* harmony export */   "aM": function() { return /* binding */ StringToESDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony exports ToISODate, ParseDate */

function StringToESDate(dateString) {
    var options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    var date = new Date(dateString);
    return new Intl.DateTimeFormat("es-ES", options).format(date);
}
function formatDate(date) {
    var months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre", 
    ];
    var day = date.getDate();
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, " de ").concat(month, ", ").concat(year);
}
function FormatSlugDate(date) {
    var months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre", 
    ];
    // Función para rellenar con ceros a la izquierda si el número es menor que 10
    var padWithZero = function(number) {
        return number.toString().padStart(2, "0");
    };
    var day = padWithZero(date.getDate());
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    return "".concat(day, "-").concat(month, "-").concat(year);
}
function FormatDateCurrentDate(date) {
    var options = {
        day: "2-digit",
        month: "long",
        year: "numeric"
    };
    var formattedDate = date.toLocaleDateString("es-ES", options).replace(/ /g, "-");
    return formattedDate.replace(/-de-/g, "-");
}
function ToISODate(date) {
    return date.toISOString().split("T")[0];
}
function ParseDate(dateString) {
    var ref = _sliced_to_array(dateString.split("-"), 3), day = ref[0], month = ref[1], year = ref[2];
    var months = {
        enero: 0,
        febrero: 1,
        marzo: 2,
        abril: 3,
        mayo: 4,
        junio: 5,
        julio: 6,
        agosto: 7,
        septiembre: 8,
        octubre: 9,
        noviembre: 10,
        diciembre: 11
    };
    // Crear la fecha en UTC
    return new Date(Date.UTC(parseInt(year), months[month.toLowerCase()], parseInt(day)));
}


/***/ }),

/***/ 14709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ transformCloudinaryURL; }
/* harmony export */ });
var transformCloudinaryURL = function(url) {
    var height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 720, width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 720;
    if (typeof url !== "string" || !url) {
        console.warn("transformCloudinaryURL called with invalid URL: ", url);
        return url;
    }
    var parts = url.split("/upload/");
    if (parts.length < 2) {
        // This check ensures that the URL structure is as expected.
        // If not, handle accordingly (e.g., return the original URL or a default one).
        return url // Returning the original URL as a fallback.
        ;
    }
    var resUrl = parts[0] + "/upload/w_".concat(width, ",h_").concat(height, ",c_fill/") + parts[1];
    return resUrl;
};


/***/ }),

/***/ 42846:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleList":"ArticleList_articleList__VWF4f","textWrap":"ArticleList_textWrap__MZbTz","cardWrap":"ArticleList_cardWrap__9Ik0t","imageWrapper":"ArticleList_imageWrapper__F8nX0","cardImage":"ArticleList_cardImage__0UIrw","overlayImage":"ArticleList_overlayImage__03IyB","cardTitle":"ArticleList_cardTitle__WZPQ1","text":"ArticleList_text__h1sP8"};

/***/ }),

/***/ 12968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleCategory_container__2FIUi","textWrap":"SingleCategory_textWrap__5AJp_","containerWrap":"SingleCategory_containerWrap__hnf5W","title":"SingleCategory_title__HACz_","imgRadius":"SingleCategory_imgRadius__qT0Pm"};

/***/ }),

/***/ 61622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topicList":"TopicList_topicList__w7tlk","topicCard":"TopicList_topicCard__ivI_9","selectedTopicCard":"TopicList_selectedTopicCard__OppKZ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,9453,1944,3544,4425,9072,1552,1146,9774,2888,179], function() { return __webpack_exec__(4599); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);